export enum SubscriptionType {
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
}

export interface SubscriptionChannel {
  subscriptionType: SubscriptionType;
  value: string;
}

export class Subscription {
  constructor(
    public firstName: string = '',
    public lastName: string = '',
    public email: string = '',
    public subCategories: string[] = [],
    public subscriptions: SubscriptionChannel[] = []
  ) {}
}
